// Version of the running web app, injected at build time (see vite.config.ts).
export const APP_BUILD = __APP_BUILD__;

/** e.g. "v2.4.1 (a1b2c3d)" */
export const APP_VERSION_LABEL = `v${APP_BUILD.version} (${APP_BUILD.commit})`;

/** e.g. "Built 03 Nov 2026, 14:05" — in the viewer's local time */
export const APP_BUILT_AT_LABEL = `Built ${new Date(APP_BUILD.builtAt).toLocaleString(undefined, {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})}`;
